import React, { useState, useEffect } from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
function MachineGuideVideos () {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const userId = queryParams.get('userId');
    const machineId = queryParams.get('machineId');
    const [classWidth, setClassWidth] = useState(0);
    const [classHeight, setClassHeight] = useState(0);
    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(window.innerHeight);
    const [smallMedia, setSmallMedia] = useState(window.innerWidth <= 768); // Adjust breakpoint as needed
    const [videos, setVideos] = useState([]);
    const [selectedVideo, setSelectedVideo] = useState(null);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [nowPName, setNowPName] = useState("");
useEffect(() => {
      const validateToken = async () => {
        const token = searchParams.get('token');
        if (!token) {
          navigate('/unauthorized'); // Redirect if no token is provided
          return;
        }
  
        try {
          const response = await axios.post('/api/validate-token', { token });
          if (!response.data.valid) {
            navigate('/unauthorized'); // Redirect if token is invalid
          }
        } catch (error) {
          console.error('Token validation failed:', error);
          navigate('/unauthorized'); // Redirect on error
        }
      };
  
      validateToken();
    }, [searchParams, navigate]);
      // Function to fetch video names from the backend
  const fetchVideos = async () => {
    try {
      const response = await axios.get('/api/videos'); // Adjust port if needed
      setVideos(response.data);
      console.log(response.data," this is videos responce");
      
    } catch (error) {
      console.error("Error fetching videos:", error);
    }
  };
    useEffect(() => {
        fetchVideos();
        const handleResize = () => {
            setSmallMedia(window.innerWidth <= 768);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    //   Function to detect client screen w * h
    useEffect(() => {
      const updateDimensions = () => {
        const newWidth = window.innerWidth;
        const newHeight = window.innerHeight;
        setWidth(newWidth);
        setHeight(newHeight);
        const newClassWidth = newWidth;
        const newClassHeight = newClassWidth * 0.75;
        setClassHeight(768);
        setClassWidth(1024);
      };
  
      // Add event listener for resize event
      window.addEventListener('resize', updateDimensions);
  
      // Initial log
      updateDimensions();
  
      // Cleanup function to remove the event listener
      return () => {
        window.removeEventListener('resize', updateDimensions);
      };
    }, []);
    const handleVideoSelect = (video, name) => {
	setNowPName(name);
        setSelectedVideo(video);
      };
    
return(
    <div className="dashboardF" style={{height: `${classHeight}px`,width: `${classWidth}px`}}>
    <div className="mapMachine guide-div" style={{padding: '2%'}}>
    {/* <div>You are in guide page</div> */}
    <div className="video-display" style={{border: '1px solid #EF7C32', borderRadius: '10px', padding: '1%'}}>
      {/* <h3>Video List:</h3> */}
      {videos.length > 0 ? (
        <>
          <div className="video-thumbnails">
            {videos.map((video, index) => {
              const videoNameWithoutExtension = video.name.split('.').slice(0, -1).join('.');
              return (
                <div key={index} className="video-item">
                  <video
                    src={`/api/videos/${video.name}`}
                    width="100%"
                    height="75%"
                    muted
                    autoPlay
                    loop
                    onClick={() => handleVideoSelect(video, videoNameWithoutExtension)}
                  />
                  <p onClick={() => handleVideoSelect(video, videoNameWithoutExtension)}>
                    {videoNameWithoutExtension}
                  </p>
                </div>
              );
            })}
          </div>
          {selectedVideo && (
            <div className="selected-video-player">
            <button className="close-button" onClick={() => setSelectedVideo(null)}>Back</button>
              <p className="sl-vd-name">Now Playing: {nowPName}</p>
              <video
                src={`/api/videos/${selectedVideo.name}`}
                style={{ width: '100%', height: '90%', padding: 0, margin:0 }}
                controls
                autoPlay
                
              />
            </div>
          )}
        </>
        ) : (
          <p>No videos available</p>
      )}
    </div>
  </div>
  </div>
)
}
export default MachineGuideVideos;
